<template>
  <div class="approve-consent-override-popup">
    <popup :close-action="closeModal" class="popup">
      <template v-slot:title>
        <div class="logo">
          <img class="logo-image" :src="require(`@/assets/icons/exclemation-mark-blue.svg`)">
        </div>
        <div class="popup-title">{{ title }}</div>
      </template>
      <template v-slot:content>
        <div>
          <div class="description">
            <span class="bold">רצית לחבר חשבונות נוספים להסכמה או למחוק ממנה חשבונות?</span>
            <span>{{sourceTypeText}} ממך למחוק את ההסכמה הקיימת וליצור אחת חדשה.</span>
          </div>
          <div class="proceed-to-consent" @click="openRedirectToOpenBankingPopup">
            הבנתי, אני רוצה להמשיך לאתר הבנק
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="footer-btn" @click="redirectToCashflow">ביטול וחזרה לתזרים</div>
      </template>
    </popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import RedirectToOpenBankingPopup from '@/base-components/onboarding/openBanking/RedirectToOpenBankingPopup';
import { mapActions } from 'vuex';
import Segment from '../../../Segment';

export default {
  name: 'ApproveConsentOverridePopup',
  props: {
    idNumber: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
    existingValidConsent: {
      type: Object,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('ApproveConsentOverridePopup', { idNumber: this.idNumber, source: this.source.name });
  },
  components: {
    Popup: BaseUI.Popup,
  },
  computed: {
    title() {
      return `חשוב לשים לב, החשבונות ב${this.sourceNameWithType} כבר מחוברים בחשבון`;
    },
    sourceNameWithType() {
      return this.source.type === 'bank' ? `בנק ${this.sourceName}` : this.sourceName;
    },
    sourceName() {
      return this.source.displayName;
    },
    sourceTypeText() {
      return this.source.type === 'bank' ? 'הבנק יבקש' : 'חברת האשראי תבקש';
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeModal']),
    closeModal() {
      Segment.trackUserInteraction('ApproveConsentOverridePopup_CloseClicked', { idNumber: this.idNumber, source: this.source.sourceName });
      this.$emit('close');
    },
    openRedirectToOpenBankingPopup() {
      this.closeModal();
      this.openModal({
        component: RedirectToOpenBankingPopup,
        props: {
          idNumber: this.idNumber,
          name: this.name,
          source: this.source,
          credentialsToUpdateMetaData: this.existingValidConsent,
        },
      });
    },
    redirectToCashflow() {
      this.closeModal();
      this.$router.push({ path: '/sr' });
    },
  },
};
</script>

<style lang="scss" scoped>

@import '~base-ui/src/scss/riseup-colors';

  .approve-consent-override-popup {
    .popup{
      padding-bottom: 0;
    }
    .popup-title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 27px;
    }

    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .logo-image {
      height: 127px;
      width: 127px;
      margin-top: 14px;
      margin-bottom: 20px;
    }

    .description {
      font-family: SimplerPro;
      margin-bottom: 27px;
      font-size: 16px;
      line-height: 22px;

      .bold {
        font-weight: bold;
      }
    }

    .proceed-to-consent {
      color: $riseup_blue;
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
      font-size: 16px;
      text-align: center;
      margin-top: 40px;
    }

    .footer-btn{
      display: flex;
      justify-content: center;
      font-size: 18px;
      color: $riseup_black;
      cursor: pointer;
    }
  }

</style>
